<template>
  <content-loader
    :width="300"
    :height="calculatedHeight"
    speed="2"
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
  >
    <rect x="8" y="18" rx="2" ry="2" width="143" height="184" />
    <rect x="165" y="105" rx="2" ry="2" width="143" height="96" />
  </content-loader>
</template>
<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'AnalyticsChartLoader',
  components: {
    ContentLoader,
  },
  computed: {
    calculatedHeight() {
      return window.innerHeight >= 900 ? 170 : window.innerHeight;
    },
  },
};
</script>


// WEBPACK FOOTER //
// AnalyticsChartLoader.vue?ba36d24c